
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/running-power-definition",
      function () {
        return require("private-next-pages/running-power-definition.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/running-power-definition"])
      });
    }
  